<ng-container
  *ngIf="isMobileView; then mobileView; else desktopView"
></ng-container>

<ng-template #desktopView>
  <div [ngClass]="{ 'text-right': hasClassTextRight }" (click)="onClick()">
    <a
      href="javascript:void(0)"
      class="rs-btn"
      [ngClass]="hasLeftPosition ? 'rs-btn-second rs-btn-nl-m' : 'rs-btn-order'"
      data-tms-event="button-click-impression"
      [attr.data-tms-button-zone]="analyticsButtonZone"
      [attr.data-tms-context]="documentReference"
      [attr.data-tms-message-info]="billingAccount?.accountNumber"
      data-tms-button-name="pay the bill"
      data-cy="myBillPayButtonLink"
      >{{ payButtonText ?? ('bills.balanceCard.action' | translate) }}</a
    >
  </div>
</ng-template>

<ng-template #mobileView>
  <a
    href="javascript:void(0)"
    (click)="onClick()"
    class="rs-btn"
    [ngClass]="
      hasLeftPosition
        ? 'rs-btn-second rs-btn-nl-m'
        : 'rs-btn-order rs-btn-nl-so'
    "
    data-tms-event="button-click-impression"
    [attr.data-tms-button-zone]="analyticsButtonZone"
    [attr.data-tms-context]="documentReference"
    [attr.data-tms-message-info]="billingAccount?.accountNumber"
    data-tms-button-name="pay the bill"
    data-cy="myBillPayButtonLink"
    >{{ payButtonText ?? ('bills.balanceCard.action' | translate) }}</a
  >
</ng-template>
